module.exports = __webpack_public_path__ + "img/index-logo.a83a0937.png";